export type PhotoConfig = {
  validation: {
    maxFileSize: number;
    maxPhotosPerCalibration: number;
    allowedMimeTypes: string[];
    maxWidth: number;
    maxHeight: number;
    minWidth: number;
    minHeight: number;
    largeFileSizeWarningThreshold: number;
    aspectRatioLimits: { min: number; max: number };
  };
  compression: {
    maxWidth: number;
    maxHeight: number;
    defaultQuality: number;
    thumbnailSize: number;
    thumbnailQuality: number;
    qualityThresholds: {
      small: { maxSize: number; quality: number };
      medium: { maxSize: number; quality: number };
      large: { maxSize: number; quality: number };
      veryLarge: { quality: number };
    };
  };
  storage: {
    metadataCacheTTL: number;
    uploadRetryDelay: number;
    maxRetryAttempts: number;
  };
  gallery: {
    virtualizationThreshold: number;
    itemHeight: number;
    overscan: number;
  };
};

export const defaultPhotoConfig: PhotoConfig = {
  validation: {
    maxFileSize: 10 * 1024 * 1024,
    maxPhotosPerCalibration: 20,
    allowedMimeTypes: ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'],
    maxWidth: 8000,
    maxHeight: 8000,
    minWidth: 100,
    minHeight: 100,
    largeFileSizeWarningThreshold: 5 * 1024 * 1024,
    aspectRatioLimits: { min: 0.1, max: 10 }
  },
  compression: {
    maxWidth: 2048,
    maxHeight: 2048,
    defaultQuality: 0.85,
    thumbnailSize: 200,
    thumbnailQuality: 0.7,
    qualityThresholds: {
      small: { maxSize: 500 * 1024, quality: 0.9 },
      medium: { maxSize: 2 * 1024 * 1024, quality: 0.85 },
      large: { maxSize: 5 * 1024 * 1024, quality: 0.8 },
      veryLarge: { quality: 0.75 }
    }
  },
  storage: {
    metadataCacheTTL: 60 * 60 * 1000,
    uploadRetryDelay: 60 * 1000,
    maxRetryAttempts: 3
  },
  gallery: {
    virtualizationThreshold: 20,
    itemHeight: 280,
    overscan: 5
  }
};

let currentConfig: PhotoConfig = { ...defaultPhotoConfig };

export const getPhotoConfig = (): PhotoConfig => currentConfig;

export const setPhotoConfig = (config: Partial<PhotoConfig>): void => {
  currentConfig = {
    ...currentConfig,
    ...config,
    validation: { ...currentConfig.validation, ...config.validation },
    compression: { ...currentConfig.compression, ...config.compression },
    storage: { ...currentConfig.storage, ...config.storage },
    gallery: { ...currentConfig.gallery, ...config.gallery }
  };
};

export const resetPhotoConfig = (): void => {
  currentConfig = { ...defaultPhotoConfig };
};
